import React from 'react'
import success from '../assets/images/icons/success.svg'
import { Apple, ApplePlayText, AuthPlayAppleButton, ButtonText, DownloadText, SuccessHeadText, SuccessText } from '../StyledComponents'
import { Button, Col, Row } from 'reactstrap'
import { Link, useNavigate } from 'react-router-dom'
import successimage from '../assets/images/auth/success.svg';
import logo from '../assets/images/logo/logo.svg';
import maelano from '../assets/images/logo/maelano-color.svg';
import playstore from '../assets/images/logo/playstore.svg'
import appleWhite from '../assets/images/logo/apple.svg'


const SuccessPasswordChange = () => {

  const navigate = useNavigate()


  const handleLoginRedirect = () => {
    navigate('/login')
  }

  return (
    <div className="d-flex justify-content-center align-items-center">
      <Row>
        <Col lg='6' md='12' className="col-style px-3 p-md-5" style={{ justifyContent: 'space-around' }}>
          <Row className='h-100'>
            <Col xl='12' lg='12' md='12' sm='12' xs='12' className='col-style' style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '1rem' }}>
                <Link className='maelano' to='/' onClick={e => e.preventDefault()}>
                  <img src={logo} style={{ color: '#3E5859', width: '50px', height: '38px', marginRight: '10px' }} />
                  <img className='img-fluid' src={maelano} alt='MAELANO' />
                </Link>
              </div>
              <div className="p-3 px-sm-2 px-lg-5" style={{
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                alignItems: "center",
              }}>
                <img className='p-2' src={success} />
                <SuccessHeadText>Password has successfully changed</SuccessHeadText>
                <SuccessText style={{ marginBottom: '48px' }}>Now go to login page to login again</SuccessText>
                <Button type="submit" block
                  color='light-primary'
                  style={{
                    color: 'white',
                    borderRadius: '20px',
                    backgroundColor: '#F2C736',
                    height: '50px',
                    maxWidth: '318px',
                  }}
                  onClick={handleLoginRedirect}
                >

                  <ButtonText>LOGIN NOW</ButtonText>

                </Button>
              </div>
              <div className='d-flex gap-2 justify-content-center' style={{ marginTop: '15px' }}>
                <AuthPlayAppleButton>
                  <Apple src={appleWhite} />
                  <div className='d-flex flex-column'>
                    <DownloadText>Download on the</DownloadText>
                    <ApplePlayText>Apple Store</ApplePlayText>
                  </div>
                </AuthPlayAppleButton>
                <AuthPlayAppleButton>
                  <Apple src={playstore} />
                  <div className='d-flex flex-column'>
                    <DownloadText>Download on the</DownloadText>
                    <ApplePlayText>Google Play</ApplePlayText>
                  </div>
                </AuthPlayAppleButton>
              </div>
            </Col>
          </Row>

        </Col>
        <Col className='d-none d-lg-flex align-items-center' lg='6' sm='12'>
          <div className='w-100 d-lg-flex align-items-center justify-content-center'>
            <img className='img-fluid' src={successimage} alt='MAELANO' style={{ objectFit: 'contain' }} />
          </div>
        </Col>


      </Row>

    </div>
  )
}

export default SuccessPasswordChange